var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,4v92H4V4H96 M100,0H0v100h100V0L100,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86,70 70,86 86,86  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "14,30 30,14 14,14   "
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "70,14 86,30 86,14  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "30,86 14,70 14,86   "
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70,30H60v4h10V30L70,30z M50,30H40v4h10V30L50,30z M34,30h-4v10h4V30L34,30z M34,50h-4v10h4V50L34,50z M40,66H30v4h10V66   L40,66z M60,66H50v4h10V66L60,66z M70,60h-4v10h4V60L70,60z M70,40h-4v10h4V40L70,40z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e33d17c4f78d498ecd946737754cf263.svg";
export { ForwardRef as ReactComponent };